const sharetribeSdk = require('sharetribe-flex-sdk');
const sdk = sharetribeSdk.createInstance({
  clientId: process.env.REACT_APP_SHARETRIBE_SDK_CLIENT_ID,
});

function getRandomInt(max) {
  return Math.floor(Math.random() * max);
}

export const getLatestListings = data => {
  return sdk.listings
    .query({
      ...data,
      include: ['author', 'images', 'author.profileImage', 'profileImage'],
      'fields.listing': ['title', 'geolocation', 'price', 'publicData', 'description'],
      'fields.user': [
        'profile.displayName',
        'profile.abbreviatedName',
        'profile.publicData',
        'profileImage',
        'profile.profileImage',
      ],
      'fields.image': ['variants.square-small', 'variants.square-small2x', 'variants.landscape-crop', 'variants.landscape-crop2x',],
    })
    .then(res => {
      const listings = res.data.data;
      const images =
        res.data.included &&
        res.data.included.filter(i => {
          return i.type === 'image';
        });
      const users =
        res.data.included &&
        res.data.included.filter(i => {
          return i.type === 'user';
        });

      if (users && users.length > 0) {
        users.forEach(u => {
          const imageId = u.relationships.profileImage.data?.id.uuid;

          const luckyImage = images.find(i => {
            return i.id.uuid === imageId;
          });

          u.profileImage = luckyImage;
        });
      }

      if (listings && listings.length > 0) {
        listings.forEach(l => {
          const imageId = l.relationships.images.data[0]?.id.uuid;
          const authorId = l.relationships.author.data?.id.uuid;

          const luckyImage = images.find(i => {
            return i?.id.uuid === imageId;
          });

          const author = users.find(u => {
            return u?.id.uuid === authorId;
          });
          l.author = author;
          l.images = [luckyImage];
        });
      }

      const listingsLeftToPush = 12 - listings.length;
      let finalListings = [...listings];

      // for (let i = 1; i <= listingsLeftToPush; i++) {
      //   finalListings.push(listings[getRandomInt(listings.length - 1)]);
      // }

      const finalListingsFiltered = finalListings.filter(l => l && l.attributes);
      return finalListingsFiltered;
    })
    .catch(e => console.log(e));
};

export const limitText = (text, limit) => {
  if (!text || !limit) {
    return null;
  }
  if (text.length > limit) {
    const newText = text.substring(0, limit) + '...';
    return newText;
  }

  return text;
};
